import * as z from "zod";

const schema = z.object({
	settlementFee: z.number().nullable().default(0),
	normalInsurance: z.number().nullable().default(0),
	taxAccountantRegistration: z.number().nullable().default(0)
});

const model = schema.transform((values) => ({
	...values
}));

export const SalesTargetResModel = {schema, model};
export type ISalesTargetResModel = z.infer<typeof SalesTargetResModel.model>;
export const DEFAULT_SALES_TARGET_RES: ISalesTargetResModel = {
	settlementFee: 0,
	normalInsurance: 0,
	taxAccountantRegistration: 0
};
